import { useQuery } from '@apollo/client';
import { Nullable, SelectOption } from 'global';

import { VOApiFilterType } from '../../filters';
import { opportunitiesListApi } from './index';

interface Response {
  voFilterOptions: {
    list: Array<SelectOption & { meta: { color: Nullable<string>; locationCategory: Nullable<string> } }>;
  };
}

interface Variables {
  input: {
    filterType: VOApiFilterType;
    metaVariables?: {
      departmentId?: string;
    };
  };
}

export function useFilterOptions(filterType: VOApiFilterType) {
  const { data, previousData, loading, error, refetch } = useQuery<Response, Variables>(
    opportunitiesListApi.getFilterOptions,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          filterType,
        },
      },
    }
  );

  return {
    error,
    refetch,
    loading,
    options: previousData?.voFilterOptions?.list ?? data?.voFilterOptions?.list ?? [],
  };
}
